import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';
import device from "vue-device-detector";

import Loading from 'vue-loading-overlay';
    // Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

import 'bootstrap';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleNotch, faPlus, faMinus, faChevronUp, faChevronDown
} from '@fortawesome/free-solid-svg-icons';
library.add(faCircleNotch, faPlus, faMinus, faChevronUp, faChevronDown);

Vue.config.productionTip = false;
Vue.use(VueToast);
Vue.use(device);
Vue.use(Loading);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
